document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.cls-bamboo-mixmatch__form');
  var LOG = '[Bamboo Mix & Match]';

  if (!form) {
    console.log(LOG, 'form not found, aborting setup');
    return;
  }

  function submitViaFetch(source) {
    console.log(LOG, 'submitViaFetch called, source:', source);

    var cartItemsEl = document.querySelector('cart-items-component');
    var sectionId = cartItemsEl && cartItemsEl.getAttribute('data-section-id');

    var formData = new FormData(form);
    // Asking for this section's HTML in the same response lets
    // cart-items-component apply it immediately (synchronously) instead of
    // doing its own separate, slower fetch — avoiding a race where the
    // drawer opens before that second fetch has finished, briefly showing
    // stale "cart is empty" content.
    if (sectionId) {
      formData.append('sections', sectionId);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (response) {
        console.log(LOG, 'fetch resolved, status:', response.status);
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.message || 'Cart add failed');
          });
        }
        return response.json();
      })
      .then(function (data) {
        console.log(LOG, 'cart add succeeded, dispatching cart:update', data);

        var sections = {};
        if (sectionId && data.sections && data.sections[sectionId]) {
          sections[sectionId] = data.sections[sectionId];
        }

        // Plain event, not the theme's CartAddEvent class: cart-drawer-component
        // and cart-items-component only check the event *name* ('cart:update')
        // and read event.detail.data.sections, so this shape is sufficient.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { sections: sections } },
          })
        );
        console.log(LOG, 'cart:update dispatched with sections:', sections);

        // cart-drawer-component's own auto-open schedules showModal() via
        // requestAnimationFrame (~16ms) immediately on the event above. With
        // the section HTML already in hand, cart-items-component's morph
        // runs synchronously in that same dispatch (no second fetch to race
        // against) — but the morph can still patch/replace the <dialog> node
        // in place without the outer cart-drawer-component ever
        // disconnecting/reconnecting, so its cached this.refs.dialog
        // (captured once, in its original connectedCallback) can go stale
        // even though the component instance itself is unchanged. Bypassing
        // the component entirely and calling showModal() on a
        // freshly-queried <dialog> (confirmed reliable, unlike the
        // cached-ref path) avoids that regardless of what the morph did.
        var freshDialog = document.querySelector('cart-drawer-component dialog');
        if (freshDialog && !freshDialog.open) {
          console.log(LOG, 'explicit showModal() on freshly-queried dialog');
          freshDialog.showModal();
        }
      })
      .catch(function (error) {
        console.error(LOG, 'Add to cart failed:', error);
      });
  }

  // Covers a real user-driven submit (click, Enter key).
  form.addEventListener('submit', function (event) {
    console.log(LOG, "'submit' event fired");
    event.preventDefault();
    submitViaFetch('submit event');
  });

  // Covers Kaching calling form.submit() programmatically after injecting
  // its bundle line-item inputs — a script-driven .submit() call never
  // fires the 'submit' event at all (a DOM quirk, not a bug), so the
  // listener above alone can't catch it. An instance-level override here
  // shadows the native method for any caller, regardless of how it's invoked.
  form.submit = function () {
    console.log(LOG, 'form.submit() override called');
    submitViaFetch('form.submit override');
  };

  console.log(LOG, 'setup complete, form found and listeners attached');
});
